<template>
  <el-dialog
    title="详情"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="600px"
  >
    <div class="dialog_box">
      <el-form label-width="100px">
        <el-form-item label="工单编号：">
          <div>{{ form.orderId }}</div>
        </el-form-item>
        <el-form-item label="事件：">
          <div>{{ form.eventContent }}</div>
        </el-form-item>
        <el-form-item label="内容：">
          <div style="max-height: 160px;overflow:scroll;line-height: 1.5;padding-top:8px;">
            {{ form.content }}
          </div>
        </el-form-item>
        <el-form-item label="受限时限：">
          <div>{{ form.timeLimit }}小时</div>
        </el-form-item>
        <el-form-item label="状态：">
          <el-tag type="warning" size="small" v-if="form.orderStatus == 1">
            进行中
          </el-tag>
          <el-tag type="success" size="small" v-if="form.orderStatus == 2">
            已结束
          </el-tag>
        </el-form-item>
      </el-form>
      <div class="interact">
        <div class="title">
          <div class="left">互动记录：</div>
          <div style="max-height: 200px;overflow:scroll;">
            <el-tag type="warning" size="small" v-if="form.orderStatus == 1">
              民警{{ form.policeName }}已受理
            </el-tag>
            <el-tag type="success" size="small" v-if="form.orderStatus == 2">
              民警{{ form.policeName }}已结单
            </el-tag>
          </div>
        </div>
        <div class="history" v-if="form.flowRecordList.length > 0">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in form.flowRecordList"
              :key="index"
              :timestamp="$Common.dateFormatDateTwo(item.replyTime)"
            >
              {{ item.replyUserName }}：{{ item.replyContent }}
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="tip" v-if="form.flowRecordList.length == 0">
          暂无互动记录
        </div>
        <div class="sel" v-if="form.orderStatus == 1">
          <el-button size="small" type="primary" @click="reply()">
            回复
          </el-button>
        </div>
      </div>
    </div>
    <interact-detail-reply
      :resize="resize"
      :orderId="orderId"
      @getInteractDetail="getInteractDetail"
    ></interact-detail-reply>
  </el-dialog>
</template>

<script>
import interactDetailReply from "./interactDetailReply.vue";
export default {
  name: "interactDetail",
  components: {
    interactDetailReply
  },
  props: {
    detailResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    orderId: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    //这里存放数据
    return {
      showDialog: false,
      form: {
        flowRecordList: []
      },
      resize: 0
    };
  },
  //监控data中的数据变化
  watch: {
    detailResize: function(val) {
      if (val) {
        this.getInteractDetail();
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    handleClose() {
      this.showDialog = false;
    },
    reply() {
      this.resize++;
    },
    async getInteractDetail() {
      let req = {
        orderId: this.orderId
      };
      let res = await this.$Http.getInteractDetail(req);
      if (res.code == 200) {
        this.form = res.data;
        this.showDialog = true;
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.dialog_box {
  padding: 10px;

  .interact {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      .left {
        width: 100px;
        padding: 0 12px 0 0;
        text-align: right;
        font-size: 14px;
        font-weight: bold;
        color: #606266;
      }
    }
    .history {
      max-height: 200px;
      overflow: scroll;
      padding-left: 20px;
    }
    .tip {
      padding: 0 20px 20px 20px;
      color: #cccccc;
    }
  }
  .sel {
    margin: 10px 20px;
  }
}
</style>
